import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { Theme } from 'fq-ui';
import { fetchEnvConfig } from './runtime-config';

Theme.applyDefaultTheme();
// Fire-and-forget: the page renders immediately regardless, and getEnv()
// falls back to the hostname-derived login URLs if a user clicks before this
// resolves (network round-trip vs. human click reaction time).
fetchEnvConfig();
ReactDOM.render(<App />, document.getElementById('root'));
